import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add response interceptor to handle auth errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect on public pages or root
      const publicPaths = ['/login', '/empresa'];
      const isPublicPage = publicPaths.some(p => window.location.pathname.startsWith(p));
      const isRoot = window.location.pathname === '/';
      if (!isPublicPage && !isRoot) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;
